// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Qq-z","imageAndVideoCount":"Rq-z","imageAndVideoContainer":"Sq-z","viewAllReviews":"Tq-z"};